module.exports = __webpack_public_path__ + "assets/img/7027be1b588ceaa16e885b14bf233e6a.png";